<template>
	<div>
		<ui-card icon="fal fa-cabinet-filing" title="Tipos de Arquivos" :obs="obs">
			<template #body>
				<ui-load-success
					v-if="loader.overlay"
					:loading="loader.overlayLoading"
					:success="loader.overlaySucess"
				/>

				<div class="area-card">
					<transition name="fade">
						<div v-show="loader.body" class="loading-card">
							<ui-load-indicator
								bgColor="#e7e9f4"
								color="#69D296"
								:h="50"
								:stroke="8"
							/>
						</div>
					</transition>

					<ui-util-box-text-slot title="Pdf" format=".pdf" design="no-bb">
						<ui-switch v-model="form.pdf.check" :checked="form.pdf.check" design="xs" />
					</ui-util-box-text-slot>

					<ui-util-box-text-slot
						title="Word"
						format=".doc, .docx, .dotx, .docm, .dotm"
						design="no-bb"
					>
						<ui-switch
							v-model="form.word.check"
							:checked="form.word.check"
							design="xs"
						/>
					</ui-util-box-text-slot>

					<ui-util-box-text-slot
						title="Excel"
						format=".xlsx, .xlsm, .xlsb, .xltm, .xls, .xml, .xlam, .xla, .xlw"
						design="no-bb"
					>
						<ui-switch
							v-model="form.excel.check"
							:checked="form.excel.check"
							design="xs"
						/>
					</ui-util-box-text-slot>

					<ui-util-box-text-slot
						title="Power Point"
						format=".ppt, .pps"
						design="no-bb"
					>
						<ui-switch
							v-model="form.powerPoint.check"
							:checked="form.powerPoint.check"
							design="xs"
						/>
					</ui-util-box-text-slot>

					<ui-util-box-text-slot title="Png" format=".png" design="no-bb">
						<ui-switch v-model="form.png.check" :checked="form.png.check" design="xs" />
					</ui-util-box-text-slot>

					<ui-util-box-text-slot title="Jpeg" format=".jpg, .jpeg" design="no-bb">
						<ui-switch
							v-model="form.jpeg.check"
							:checked="form.jpeg.check"
							design="xs"
						/>
					</ui-util-box-text-slot>

					<ui-util-box-text-slot title="Gif" format=".gif" design="no-bb">
						<ui-switch v-model="form.gif.check" :checked="form.gif.check" design="xs" />
					</ui-util-box-text-slot>

					<ui-util-box-text-slot
						title="Compactados"
						format=".zip, .rar, .7z"
						design="no-bb"
					>
						<ui-switch v-model="form.zip.check" :checked="form.zip.check" design="xs" />
					</ui-util-box-text-slot>

					<ui-util-box-text-slot
						title="Vídeos"
						format=".avi, .mp4, .mpeg, .mov, .3gp, .3g2, .flv"
						design="no-bb"
					>
						<ui-switch
							v-model="form.video.check"
							:checked="form.video.check"
							design="xs"
						/>
					</ui-util-box-text-slot>

					<ui-util-box-text-slot title="Áudios" format=".wma, .mp2, .mp3">
						<ui-switch
							v-model="form.audio.check"
							:checked="form.audio.check"
							design="xs"
						/>
					</ui-util-box-text-slot>
				</div>
			</template>

			<template #fl></template>
			<template #fr>
				<ui-button type="submit" design="md success" :disabled="!canSubmit" @click="submit"
					>Salvar</ui-button
				>
			</template>
		</ui-card>
	</div>
</template>

<script>
	import { uiCard } from '@/components/ui/cards'
	import { uiButton } from '@/components/ui/buttons'
	import { uiSwitch } from '@/components/ui/form'
	import { uiUtilBoxTextSlot } from '@/components/ui/form/util'
	import { uiLoadIndicator } from '@/components/ui'
	import { uiLoadSuccess } from '@/components/ui/overlays'

	import { utilMixin, formMixin, alertMixin } from '@/mixins'
	import { getConfig, saveConfig } from '../../util/methods'

	import { defaultForm } from './util/data'

	const defaultDisabled = () => ({
		pdf: false,
		word: false,
		excel: false,
		powerPoint: false,
		png: false,
		jpeg: false,
		gif: false,
		zip: false,
		video: false,
		audio: false,
	})

	const defaultLoader = () => ({
		body: false,
		overlay: false,
		overlayLoading: true,
		overlaySucess: true,
	})

	export default {
		components: {
			uiCard,
			uiUtilBoxTextSlot,
			uiButton,
			uiSwitch,
			uiLoadSuccess,
			uiLoadIndicator,
		},

		mixins: [utilMixin, formMixin, alertMixin],

		data() {
			return {
				form: { ...defaultForm() },
				disabled: { ...defaultDisabled() },
				loader: { ...defaultLoader() },
				configFiles: {},
				oldForm: {},
			}
		},

		async created() {
			this.loader.body = true
			this.configFiles = await this.getConfig('configFiles', 'value_long')
			this.verifyChecks(this.configFiles)
			this.loader.body = false
			this.$mx_copyOldForm()
		},

		computed: {
			canSubmit() {
				return this.$mx_isFormChanged && !this.loader.body
			},

			validateData() {
				const form = this.$mx_copyObject(this.form)
				let mimeType = []
				for (let type in form) {
					if (form[type].check) mimeType.push(...form[type].data)
				}
				return mimeType
			},

			obs() {
				if (this.configFiles.maxGeneralDisk)
					return `Limite máximo de armazenamento incluso no seu plano: <strong>${this.configFiles.maxGeneralDisk} MB.</strong>`
				else return ''
			},
		},

		methods: {
			getConfig,
			saveConfig,

			loopSave(method, config, input, type) {
				const data = {
					mimeType: [...input.data],
				}
				method(config, data, type)
			},

			verifyChecks(data) {
				const dm = data.mimeType
				const form = this.form
				form.pdf.check = dm.includes('application/pdf')
				form.word.check = dm.includes('application/msword')
				form.excel.check = dm.includes('application/vnd.ms-excel')
				form.powerPoint.check = dm.includes('application/vnd.ms-powerpointtd')
				form.png.check = dm.includes('image/png')
				form.jpeg.check = dm.includes('image/jpeg')
				form.gif.check = dm.includes('image/gif')
				form.zip.check = dm.includes('application/zip')
				form.video.check = dm.includes('video/mp4')
				form.audio.check = dm.includes('audio/mpeg')
			},

			async submit() {
				try {
					this.loader.overlay = true
					this.loader.overlayLoading = true

					const configFiles = this.$mx_copyObject(this.configFiles)
					configFiles.mimeType = this.validateData

					await this.saveConfig('configFiles', configFiles, 'value_long')

					setTimeout(() => {
						this.loader.overlayLoading = false
						this.loader.overlaySucess = true
						setTimeout(() => {
							this.loader.overlay = false
						}, 500)
					}, 500)

					this.$mx_copyOldForm()
					//...
				} catch (error) {
					this.$mx_alertThisOnError(error)
					this.loader.overlaySucess = false
					setTimeout(() => {
						this.loader.overlay = false
					}, 1000)
				}
			},
		},
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>
